<template>
    <div class="banner bng-casino-banner-registration-bonus">
        <img
            :src="isMobilePhone ? '/static/banners/casino-home-banner/mobile/registration_bonus.jpg' : '/static/banners/casino-home-banner/desktop/registration_bonus.jpg'"
        />
        <div class="content">
            <div>
                <div>
                    <b>{{"components.common.banners.casino-banners.registration-bonus.msg1" | translate}}</b>
                    <span>{{"components.common.banners.casino-banners.registration-bonus.msg2" | translate}}</span>
                </div>
                <strong v-if="bonusAmount">{{bonusAmount | currency(currency)}}</strong>
            </div>
            <div v-if="!isRegistration && !isLoggedIn">
                <router-link
                    :to="{name:'registration-default'}"
                >{{"components.common.banners.casino-banners.registration-bonus.registration link" | translate}}</router-link>
            </div>
        </div>
        <div class="detailed">
            <a @click="goToBonusRules()">{{"components.common.banners.casino-banners.registration-bonus.read more" | translate}}</a>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'casino-banner-registration-bonus',
    props: {
        currency: {
            type: String
        }
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isRegistration() {
            return this.$route.path.indexOf('registration') !== -1;
        },
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        bonusAmount() {
            if (!this.currency || !this.client) return null;
            var cur =
                this.client.bonus.registration &&
                this.client.bonus.registration.currencies &&
                this.client.bonus.registration.currencies.filter(c => c.currency == this.currency)[0];
            if (!cur) return null;
            return cur.amount;
        },
        isMobilePhone() {
            return isMobile.phone;
        }
    },
    methods: {
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/casino-banners/registration-bonus.vue